module.exports = __webpack_public_path__ + "static/c8-7a454a648357ff69f1cc2e05f60dd073.jpg";